import Axios from 'axios';
import QueryBuilder from 'query-string';
import * as ApiHelper from '../utils/apiHelper';
import * as TokenHelpers from '../utils/tokenHelpers';
import * as ProductUtils from '../utils/productHelpers'

var departmentsKey = 'department_list';
var categoriesKey = 'category_list';
var productsKey = 'products';
var filterKey = 'filters';
var productInfoKey = 'product_info';

const depKeys = {
  "WHITE WINE": 'Pinot Grigio • Sauv Blanc • Chard',
  "SPARKLING WINE": 'Champagne • Prosecco • Brut',
  "RED WINE": 'Cabernet • Pinot Noir • Malbec',
  "ROSE WINE": 'French • Local',
  "MIXERS & SUPPLIES": 'Juice • Coffee • Soda • Ice',
  "PHARMACY & MORE": 'Medicine • Household Goods • Pet Food',
  "TOBACCO": 'Cigars • Cigarettes • E Cigs',
  "LIQUOR": 'Whiskey • Tequila • Scotch • Vodka • Rum',
  "SNACKS": 'Chips • Cookies • Cheese • Candy',
  "BEER": 'Domestic • Craft • Import'
}

let productFilters = {
  filterby_sizes: {
    id: 'filterby_sizes',
    name: 'Sizes',
    index: 'Size',
    itemType: 'checkbox',
    items: [],
    products: {}
  },
  filterby_description: {
    id: 'filterby_description',
    name: 'Descriptions',
    index: 'Sub Description 2',
    itemType: 'checkbox',
    items: [],
    products: {}
  },
  filterby_location: {
    id: 'filterby_location',
    name: 'Locations',
    index: 'Sub Description 3',
    itemType: 'checkbox',
    items: [],
    products: {}
  },
  filterby_vintage: {
    id: 'filterby_vintage',
    name: 'Vintage',
    index: 'Vintage',
    itemType: 'checkbox',
    items: [],
    products: {},
  },
  filterby_range: {
    id: 'filterby_range',
    name: 'Range',
    index: 'PriceB',
    itemType: 'checkbox',
    items: [],
    products: {}
  }
}

export function fetchDepartments() {

  return new Promise((resolve, reject) => {
    Axios({
      url: ApiHelper.API_ROOT + '/products/departments',
      method: 'get',
      headers: ApiHelper.getRequestHeaders(false)
    }).then(function(response) {
      resolve(response.data.data)
    }).catch(function(error) {
      reject({error: error.response.data})
    });
  });
}

export function fetchProducts(params) {

  return new Promise((resolve, reject) => {

    if (params && !(params.category || params.department)) {
      reject("category or department must be provided to fetch products");
    }
    if (!params.limit)
      params.limit = 20;
    if (!params.skip)
      params.skip = 0;

    let queryParams = buildProductsFetchQueryParams(params);
    let productsFetchUrl = `${ApiHelper.API_ROOT}/products/${params.category
      ? 'category'
      : 'departments'}?${QueryBuilder.stringify(queryParams)}`;

    var cacheKey = getProductStoreKey(params)
    var cachedProducts = ProductUtils.getFromStore(cacheKey);
    if (!params.filters && cachedProducts) {
      resolve(cachedProducts)
      console.info("PRODUCTS_CACHED [" + cacheKey + "]: ", cachedProducts);
    } else {
      console.log("Product fetch url..........", productsFetchUrl);
      Axios({
        url: productsFetchUrl,
        method: 'get',
        headers: ApiHelper.getRequestHeaders(false)
      }).then(function(response) {
        let products = response.data.data;
        if (!!params.filters)
          ProductUtils.saveToStore(cacheKey, products)
        resolve(products);
        console.info("PRODUCTS_FETCHED : ", products);
      }).catch(function(error) {
        reject({error: error.response.data})
      });
    }

  })
}

export function getBestSeller(params) {

  return new Promise((resolve, reject) => {

    if (!params.limit)
      params.limit = 20;
    if (!params.skip)
      params.skip = 0;

    let queryParams = buildProductsFetchQueryParams(params);
    let productsFetchUrl = `${ApiHelper.API_ROOT}/products/bestsellers?${QueryBuilder.stringify(queryParams)}`;

    Axios({
      url: productsFetchUrl,
      method: 'get',
      headers: ApiHelper.getRequestHeaders(false)
    }).then(function(response) {
      let products = response.data.data;
      // if(!!params.filters) ProductUtils.saveToStore(cacheKey, products)
      resolve(products);
      console.info("PRODUCTS_FETCHED : ", products);
    }).catch(function(error) {
      reject({error: error.response.data})
    });

  })
}

export function getSpecials(params) {

  return new Promise((resolve, reject) => {

    if (!params.limit)
      params.limit = 20;
    if (!params.skip)
      params.skip = 0;

    let queryParams = buildProductsFetchQueryParams(params);
    let productsFetchUrl = `${ApiHelper.API_ROOT}/products/specials?${QueryBuilder.stringify(queryParams)}`;

    Axios({
      url: productsFetchUrl,
      method: 'get',
      headers: ApiHelper.getRequestHeaders(false)
    }).then(function(response) {
      let products = response.data.data;
      resolve(products);
      console.info("PRODUCTS_FETCHED : ", products);
    }).catch(function(error) {
      reject({error: error.response.data})
    });

  });
}

export function getNewArrivals(params) {

  return new Promise((resolve, reject) => {

    if (!params.limit)
      params.limit = 20;
    if (!params.skip)
      params.skip = 0;

    let queryParams = buildProductsFetchQueryParams(params);
    let productsFetchUrl = `${ApiHelper.API_ROOT}/products/newarrivals?${QueryBuilder.stringify(queryParams)}`;

    Axios({
      url: productsFetchUrl,
      method: 'get',
      headers: ApiHelper.getRequestHeaders(false)
    }).then(function(response) {
      let products = response.data.data;
      // if(!!params.filters) ProductUtils.saveToStore(cacheKey, products)
      resolve(products);
      console.info("PRODUCTS_FETCHED : ", products);
    }).catch(function(error) {
      reject({error: error.response.data})
    });

  })
}

export function getSearchResults(params) {

  return new Promise((resolve, reject) => {
    params.search = params.keyword;
    let queryParams = buildProductsFetchQueryParams(params);
    console.log(params)
    let productsFetchUrl = `${ApiHelper.API_ROOT}/products/?${QueryBuilder.stringify(queryParams)}`;
    Axios({
      url: productsFetchUrl,
      method: 'post',
      headers: ApiHelper.getRequestHeaders(false)
    }).then(function(response) {
      let products = response.data.data;
      // if(!!params.filters) ProductUtils.saveToStore(cacheKey, products)
      resolve(products);
      console.info("PRODUCTS_FETCHED : ", products);
    }).catch(function(error) {
      reject({error: error.response.data})
    });

  })
}

export function getFeaturedProducts(department, params = {}) {
  return new Promise((resolve, reject) => {
    params.department = department;
    let queryParams = buildProductsFetchQueryParams(params);
    let productsFetchUrl = `${ApiHelper.API_ROOT}/products/featured?${QueryBuilder.stringify(queryParams)}`;

    Axios({
      url: productsFetchUrl,
      method: 'get',
      headers: ApiHelper.getRequestHeaders(false)
    }).then(function(response) {
      let products = response.data.data;
      // if(!!params.filters) ProductUtils.saveToStore(cacheKey, products)
      resolve(products);
      console.info("PRODUCTS_FETCHED : ", products);
    }).catch(function(error) {
      reject({error: error.response.data})
    });

  })
}

export function getFilters(options) {

  let cacheKey,
    dataToSend;

  _resetFilters();

  console.log("GET_FILTERS_OPTIONS", options);

  return new Promise((resolve, reject) => {

    if (options.type === 'category') {
      cacheKey = filterKey + '_' + options.name;
      dataToSend = '?category=' + encodeURIComponent(options.name);
    } else if (options.type === 'department') {
      cacheKey = filterKey + '_' + options.name;
      dataToSend = '?department=' + encodeURIComponent(options.name);
    } else {
      cacheKey = filterKey;
      dataToSend = '';
    }

    if(options.specialSale) {
        dataToSend = dataToSend + '&specialSale=' + options.specialSale;
        cacheKey = cacheKey + '_' + options.specialSale;
    }

    let cachedFilters = ProductUtils.getFromStore(cacheKey);
    if (cachedFilters) {
      productFilters['filterby_sizes'].items = cachedFilters.Sizes;
      productFilters['filterby_description'].items = cachedFilters.Descriptions;
      productFilters['filterby_location'].items = cachedFilters.Locations;
      resolve(productFilters)
    } else {
      Axios({
        url: `${ApiHelper.API_ROOT}/products/filters${dataToSend}`,
        method: 'get',
        headers: ApiHelper.getRequestHeaders(false)
      }).then(function(response) {
        console.log('Get filters success', response.data);
        let filters = response.data;
        ProductUtils.saveToStore(cacheKey, filters)
        productFilters['filterby_sizes'].items = filters.Sizes;
        productFilters['filterby_description'].items = filters.Descriptions;
        productFilters['filterby_location'].items = filters.Locations;
        productFilters['filterby_vintage'].items = filters.Vintage;
        productFilters['filterby_range'].items = filters.PriceRange;
        resolve(productFilters);
      }).catch(function(error) {
        reject({error: error.response.data})
      });
    }

  })

}

export function getSearchFilters(options) {
  const dataToSend = `?q=${options.q}`
  return new Promise((resolve, reject) => {
    Axios({
      url: `${ApiHelper.API_ROOT}/products/filters${dataToSend}`,
      method: 'get',
      headers: ApiHelper.getRequestHeaders(false)
    }).then(function(response) {
      console.log('Get filters success', response.data);
      let filters = response.data;
      productFilters['filterby_sizes'].items = filters.Sizes;
      productFilters['filterby_description'].items = filters.Descriptions;
      productFilters['filterby_location'].items = filters.Locations;
      productFilters['filterby_range'].items = filters.PriceRange;
      productFilters['filterby_vintage'].items = filters.Vintage;
      resolve(productFilters);
    }).catch(function(error) {
      reject({error: error.response.data})
    });
  })
}

export function fetchProductDetails(productId) {
  return new Promise((resolve, reject) => {
    Axios({
      url: `${ApiHelper.API_ROOT}/products/${productId}`,
      method: 'get',
      headers: ApiHelper.getRequestHeaders(false)
    }).then(function(response) {
      resolve(response.data)
    }).catch(function(error) {
      reject({error: error.response.data})
    });
  });
}

function getProductStoreKey(params) {

  let categoryType = params.category
    ? params.category
    : params.department;
  let key = productsKey + '_' + categoryType;

  if (params.sortOptions && params.sortOptions.Description) {
    key += '_' + params.sortOptions.Description + 'name' + '_' + params.limit + '_' + params.skip;
  } else if (params.sortOptions && params.sortOptions.PriceB) {
    key += '_' + params.sortOptions.PriceB + 'price' + '_' + params.limit + '_' + params.skip;
  }
  console.error("Sort option keys", key);
  return key;
}

function buildProductsFetchQueryParams(params) {
  let sortOptions = params && params.sortOptions
    ? params.sortOptions
    : null;
  let filters = params && params.filters
    ? params.filters
    : null;

  if (sortOptions && sortOptions.Description) {
    params['name'] = sortOptions.Description;
  }
  if (sortOptions && sortOptions.PriceB) {
    params['priceb'] = sortOptions.PriceB;
  }

  if (filters) {
      if (filters['filterby_sizes']) {
        params['size'] = JSON.stringify(filters['filterby_sizes']);
      }
      if (filters['filterby_description']) {
        params['description'] = JSON.stringify(filters['filterby_description'])
      }
      if (filters['filterby_location']) {
        params['location'] = JSON.stringify(filters['filterby_location'])
      }
    if (filters['filterby_vintage']) {
      params['vintage'] = JSON.stringify(filters['filterby_vintage']);
    }
      if(filters['filterby_range']) {
        params['range'] = JSON.stringify(filters['filterby_range']);
      }
  }

  delete params.sortOptions;
  delete params.filters;
  console.log("FETCH_PRODUCTS_QUERY_PARAMS", params);
  return params
}

function _resetFilters() {
  Object.keys(productFilters).forEach(function(filterKey) {
    productFilters[filterKey].items = [];
    productFilters[filterKey].products = {};
  });
}



// WEBPACK FOOTER //
// ./src/services/products.js